var modal0 = document.getElementById('modal0');
var btn0 = document.getElementById("p0");
var span0 = document.getElementsByClassName("close-omy-bubble0")[0];
var modal1 = document.getElementById('modal1');
var btn1 = document.getElementById("p1");
var span1 = document.getElementsByClassName("close-omy-bubble1")[0];
var modal2 = document.getElementById('modal2');
var btn2 = document.getElementById("p2");
var span2 = document.getElementsByClassName("close-omy-bubble2")[0];
var modal3 = document.getElementById('modal3');
var btn3 = document.getElementById("p3");
var span3 = document.getElementsByClassName("close-omy-bubble3")[0];
var modal4 = document.getElementById('modal4');
var btn4 = document.getElementById("p4");
var span4 = document.getElementsByClassName("close-omy-bubble4")[0];
var modal5 = document.getElementById('modal5');
var btn5 = document.getElementById("p5");
var span5 = document.getElementsByClassName("close-omy-bubble5")[0];
var modal6 = document.getElementById('modal6');
var btn6 = document.getElementById("p6");
var span6 = document.getElementsByClassName("close-omy-bubble6")[0];
var modal7 = document.getElementById('modal7');
var btn7 = document.getElementById("p7");
var span7 = document.getElementsByClassName("close-omy-bubble7")[0];
var modal8 = document.getElementById('modal8');
var btn8 = document.getElementById("p8");
var span8 = document.getElementsByClassName("close-omy-bubble8")[0];
var map = document.getElementById("map");

var map0 = document.getElementById("map0");
var map1 = document.getElementById("map1");
var map2 = document.getElementById("map2");
var map3 = document.getElementById("map3");
var map4 = document.getElementById("map4");
var map5 = document.getElementById("map5");
var map6 = document.getElementById("map6");
var map7 = document.getElementById("map7");
var map8 = document.getElementById("map8");

function preloadImage(url)
{
    var img=new Image();
    img.src=url;
}

preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/university.png?v=1585565320");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/agora.png?v=1585565397");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/olympic.png?v=1585565351");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/vouli.png?v=1585565308");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/acropolis.png?v=1585565413");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/asteroskopio.png?v=1585565385");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/niarxos.png?v=1585565363");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/riviera.png?v=1585565336");
preloadImage("//cdn.shopify.com/s/files/1/0048/3904/7257/files/kalimarmaro.png?v=1585565373");



btn0.onclick = function() {
    modal0.style.display = "block";
    modal1.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
    modal8.style.display = "none";
    map0.style.display = "block";
    map0.src= '//cdn.shopify.com/s/files/1/0048/3904/7257/files/university.png?v=1585565320';
}

span0.onclick = function() {
    modal0.style.display = "none";
}

btn1.onclick = function() {
    modal1.style.display = "block";
    modal0.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
    modal8.style.display = "none";
    map1.style.display = "block";
    map1.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/agora.png?v=1585565397";
}

span1.onclick = function() {
    modal1.style.display = "none";
}

btn2.onclick = function() {
    modal2.style.display = "block";
    modal1.style.display = "none";
    modal0.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
    modal8.style.display = "none";
    map2.style.display = "block";
    map2.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/olympic.png?v=1585565351";
}

span2.onclick = function() {
    modal2.style.display = "none";
}

btn3.onclick = function() {
    modal3.style.display = "block";
    modal1.style.display = "none";
    modal2.style.display = "none";
    modal0.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
    modal8.style.display = "none";
    map3.style.display = "block";
    map3.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/vouli.png?v=1585565308";
}

span3.onclick = function() {
    modal3.style.display = "none";
}

btn4.onclick = function() {
    modal4.style.display = "block";
    modal1.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal0.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
    modal8.style.display = "none";
    map4.style.display = "block";
    map4.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/acropolis.png?v=1585565413";
}

span4.onclick = function() {
    modal4.style.display = "none";
}

btn5.onclick = function() {
    modal5.style.display = "block";
    modal1.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal0.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
    modal8.style.display = "none";
    map5.style.display = "block";
    map5.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/asteroskopio.png?v=1585565385";
}

span5.onclick = function() {
    modal5.style.display = "none";
}

btn6.onclick = function() {
    modal6.style.display = "block";
    modal1.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal0.style.display = "none";
    modal7.style.display = "none";
    modal8.style.display = "none";
    map6.style.display = "block";
    map6.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/niarxos.png?v=1585565363";
}

span6.onclick = function() {
    modal6.style.display = "none";
}

btn7.onclick = function() {
    modal7.style.display = "block";
    modal1.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal0.style.display = "none";
    modal8.style.display = "none";
    map7.style.display = "block";
    map7.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/riviera.png?v=1585565336";
}

span7.onclick = function() {
    modal7.style.display = "none";
}

btn8.onclick = function() {
    modal8.style.display = "block";
    modal1.style.display = "none";
    modal2.style.display = "none";
    modal3.style.display = "none";
    modal4.style.display = "none";
    modal5.style.display = "none";
    modal6.style.display = "none";
    modal7.style.display = "none";
    modal0.style.display = "none";
    map8.style.display = "block";
    map8.src= "//cdn.shopify.com/s/files/1/0048/3904/7257/files/kalimarmaro.png?v=1585565373";
}

span8.onclick = function() {
    modal8.style.display = "none";
}

window.onclick = function(event) {
  if (event.target == modal0) {
    modal0.style.display = "none";
  }
}
